import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectService } from 'src/app/_services/project/project.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectResourcesService } from 'src/app/_services/projectResources/project-resources.service';

@Component({
  selector: 'app-sub-project',
  templateUrl: './sub-project.component.html',
  styleUrls: ['./sub-project.component.scss']
})
export class SubProjectComponent implements OnInit {
  form: FormGroup;
  subProjectForm
  tenantId: string;
  currentProjectId: any;
  userDropdownList = [];
  getUserName: any;
  parentProjectId: any;
  parentProjectName: any;
  isPMOLeadORManager: boolean = false;
  currentUser: any;

  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private snackBar: MatSnackBar,
    private projectResourcesService: ProjectResourcesService,
  ) {
    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.subProjectForm = new FormGroup({
      archived: new FormControl('false'),
      createdBy: new FormControl(null),
      createdDatetime: new FormControl(new Date().toISOString()),
      customer: new FormControl("", Validators.required),
      decisionDate: new FormControl(''),
      endDate: new FormControl(null, Validators.required),
      modifiedBy: new FormControl(null),
      modifiedDatetime: new FormControl(null),
      projectCode: new FormControl("",Validators.compose([Validators.required,Validators.pattern('^[0-9]*$')])),
      projectController: new FormControl("",[Validators.required]),
      projectDescription: new FormControl(""),
      projectEnterMs: new FormControl(""),
      projectManager: new FormControl("",[Validators.required]),
      projectManagerId: new FormControl(),
      projectName: new FormControl("",[Validators.required]),
      projectStatus: new FormControl(''),
      quotationDate: new FormControl(null),
      quotationManager: new FormControl(""),
      remainingHours: new FormControl(''),
      roughBudgetIndication: new FormControl(""),
      seatCapacity: new FormControl(''),
      seatingRows: new FormControl(''),
      startDate: new FormControl(null,[Validators.required]),
      totalHours: new FormControl(''),
      parentId: new FormControl(''),
      percentWorkCompleted: new FormControl(''),
    })
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');
    this.getUserList();
    this.getProjectById();

    if (this.currentProjectId) this.getSubProjectById(this.currentProjectId)
  }

  // getter for easy access to form fields
  get f() {
    return this.subProjectForm.controls;
  }

  getProjectById(){
    this.projectService.getProjectById(this.parentProjectId).subscribe((response: any) =>{
      this.parentProjectName = response.id + " . " + response.projectName;
    });
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  backToMyProject() {
    this.router.navigate([this.tenantId + '/dashboard/project/project-list/sub-project-list'], { queryParams: { projectID: this.parentProjectId} });
  }

  openProjectTab(param) {
    this.router.navigate([this.tenantId + `/dashboard/project/project-list/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId} }); // pass current project id as parameter
  }

  getSubProjectById(id) {
    this.projectService.getProject(id).subscribe((response: any) => {
      let lead = this.currentUser.id + " . " + this.currentUser.firstName + " " + this.currentUser.lastName;
      if(response.projectManagerId === this.currentUser.id || response.projectController === lead){
        this.isPMOLeadORManager = true;
      }
      else if(response.parentId){
        this.projectService.getProject(response.parentId).subscribe((response1: any) => {
          let parentLead = this.currentUser.id + " . " + this.currentUser.firstName + " " + this.currentUser.lastName;
          if(response1.projectManagerId === this.currentUser.id || response1.projectController === parentLead){
            this.isPMOLeadORManager = true;
          }
        }); 
      }
      
      this.subProjectForm.patchValue({
        createdBy: response.createdBy,
        createdDatetime: response.createdDatetime,
        customer: response.customer,
        decisionDate: response.decisionDate,
        endDate: response.endDate,
        modifiedBy: response.modifiedBy,
        modifiedDatetime: response.modifiedDatetime,
        projectCode: response.projectCode,
        projectController: response.projectController,
        projectDescription: response.projectDescription,
        projectEnterMs: response.projectEnterMs,
        projectManager: response.projectManagerId + " . " + response.projectManager,
        projectName: response.projectName,
        projectStatus: response.projectStatus,
        remainingHours: response.remainingHours,
        startDate: response.startDate,
        totalHours: response.totalHours,
        parentId: response.parentId,
        percentWorkCompleted: response.percentWorkCompleted,
      })
    }, error => {
      this.openSnackBar(error);
    })
  }

  createSubProject(){
    if(this.subProjectForm.value) {
      this.subProjectForm.value.projectManagerId = parseInt(this.subProjectForm.value.projectManager.toString().split(".")[0].trim());
      this.subProjectForm.value.projectManager = this.subProjectForm.value.projectManager.toString().split(".")[1].trim();
    }
    this.subProjectForm.value.parentId = this.parentProjectId;
    this.projectService.createProject(this.subProjectForm.value).subscribe((response: any) => {
      this.subProjectForm.value.projectManager = this.subProjectForm.value.projectManagerId + " . " + this.subProjectForm.value.projectManager;
      this.createProjectResource(response.id);
      this.backToMyProject()
    }, error => {
      this.openSnackBar(error);
    })
  }

  createProjectResource(projectId) {
    if(this.subProjectForm.get('projectManager').value != null){
      if(this.subProjectForm.get('projectManager').value.split(' . ').length === 2){
        let details = {
          projectId : projectId,
          userId : this.subProjectForm.get('projectManager').value.split(' . ')[0],
          userName : this.subProjectForm.get('projectManager').value.split(' . ')[1],
          projectRole: "Manager",
          projectAdminBoolean: true,
          startDate: this.subProjectForm.get('startDate').value,
          endDate: this.subProjectForm.get('endDate').value,
        }
        this.projectResourcesService.createprojectResources(details).subscribe((response: any) => {
         });
      }
    }

    if(this.subProjectForm.get('projectController').value != null){
      if(this.subProjectForm.get('projectController').value.split(' . ').length === 2){
        let detailsLead = {
          projectId : projectId,
          userId : this.subProjectForm.get('projectController').value.split(' . ')[0],
          userName : this.subProjectForm.get('projectController').value.split(' . ')[1],
          projectRole: "Lead",
          projectAdminBoolean: true,
          startDate: this.subProjectForm.get('startDate').value,
          endDate: this.subProjectForm.get('endDate').value,
        }
        this.projectResourcesService.createprojectResources(detailsLead).subscribe((response: any) => {
        });
      }
    }
  }

  updateSubProject(){
    if(this.subProjectForm.value) {
      this.subProjectForm.value.projectManagerId = parseInt(this.subProjectForm.value.projectManager.toString().split(".")[0].trim());
      this.subProjectForm.value.projectManager = this.subProjectForm.value.projectManager.toString().split(".")[1].trim();
    }
    this.subProjectForm.value.parentId = this.parentProjectId;
    this.projectService.updateProject(this.currentProjectId, this.subProjectForm.value).subscribe(response => {
      this.subProjectForm.value.projectManager = this.subProjectForm.value.projectManagerId + " . " + this.subProjectForm.value.projectManager;
      this.backToMyProject()
    }, error => {
      this.openSnackBar(error);
    })
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

}
